const contentLength = {
  micro: { min: 0, max: 0.5, label: '< 0.5 hours' },
  short: { min: 0.5, max: 1, label: '0.5 - 1 hour' },
  middle: { min: 1, max: 1.5, label: '1 - 1.5 hours'},
  long: { min: 1.5, label: '>= 1.5 hours' }
}

export default contentLength;


// WEBPACK FOOTER //
// ./src/constants/content-length.js